import React from "react";
import { connect } from "react-redux";
import { callService, goTo } from "../tools";
import { movil } from "../app-movil";
import ContratoMediosForm from "./contrato-medios.frm";
import Modal from '../generalcomponets/modal-mobile';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		hashOne: state.registro.hashOne,
		hashTwo: state.registro.hashTwo,
		dispositivo: state.global.dispositivo,
		password: state.registro.password,
		pregunta1: state.registro.pregunta1,
		pregunta2: state.registro.pregunta2,
		respuesta1: state.registro.respuesta1,
		respuesta2: state.registro.respuesta2,
		mediosElectronicos: state.contrato.mediosElectronicos,
		email: state.registro.email,
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		alertaClose: (sMensaje, fnClose) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje": sMensaje, "accion": fnClose });
		},
		finalizar: (sMensaje, fnClose) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "¡Bienvenido!", "mensaje": sMensaje, "accion": fnClose });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		alertaClose: (sMensaje, fnClose) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje": sMensaje, "accion": fnClose });
		},
		finalizar: (sMensaje, fnClose) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "¡Bienvenido!", "mensaje": sMensaje, "accion": fnClose });
		},
		siguientePaso: () => {
			dispatch({ "type": "CONTRATOS_PASO", "paso": 5 });
		},
		declinarPaso: () => {
			dispatch({ "type": "CONTRATOS_PASO", "paso": 4 });
		},
		registrarDatos: (bAccept) => {
			dispatch({ "type": "CONTRATOS_MEDIOS_ELECTRONICOS", "mediosElectronicos": bAccept });
		},
		setPaso: (paso) => {
			dispatch({ "type": "CONTRATOS_PASO", "paso": paso });
		},
		limpiarRegistro: () => {
			dispatch({ "type": "LIMPIAR_REGISTRO" });
			dispatch({ "type": "LIMPIAR_REGISTRO_ASISTIDO" });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class ContratoMedios extends React.Component {
	state = {
		isModalSuccessOpened: false,
		isModalErrorOpened: false,
		modalMesage: { type: null, title: null, message: null },
		errorAndRedirect: false
	}

	submit = (data) => {
		return new Promise((resolve) => {
			this.props.registrarDatos(data.acepto);

			if (data.acepto == true) {
				console.log("acepto mediosElectronicos: " + data.acepto);
				let $this = this;
				$this.props.loader(true);

				// GOOGLE TAG MANAGER //
				this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-TERMINOS-ACEPTAR", "dispositivo": this.props.dispositivo });
				var type = (data.acepto == true) ? "EVENT_REGISTRO_SIG-CONSENTIMIENTO-ACEPTAR" : "EVENT_REGISTRO_SIG-CONSENTIMIENTO-RECHAZAR";
				this.props.tagManager({ "type": type, "dispositivo": this.props.dispositivo });

				let llamaServicio = new callService({
					service: "registro.datosContratos",
					secure: true,
					data: {
						hashOne: this.props.hashOne,
						hashTwo: this.props.hashTwo,
						password: this.props.password,
						pregunta1: this.props.pregunta1,
						pregunta2: this.props.pregunta2,
						respuesta1: this.props.respuesta1,
						respuesta2: this.props.respuesta2,
						mediosElectronicos: data.acepto
						//datosPersonales: this.props.avisoAceptado
					}
				}).execute().then((respuesta) => {
					console.log("Respuesta", respuesta);
					$this.props.loader(false);

					if (respuesta.aceptacionContratos.banExito) {
						if (this.props.dispositivo === 'app') {
							//activador del modal en movil
							this.openModalSucessParent()
						} else {
							$("#modal-bienvenida").modal({ backdrop: "static", keyboard: false });
						}
					}
				}).catch((error) => {
					console.log("Error", error);
					$this.props.loader(false);
					if (this.props.dispositivo === 'app') {
						if (error.message.codigoError) {
							if (error.message.codigoError == "eCl00026")
								this.openModalErrorParent('error', 'Error', error.message.mensajeTecnico, true)
							else
								if (error.message.mensaje)
									this.openModalErrorParent('error', error.message.codigoError, error.message.mensaje);
								else
									this.openModalErrorParent('error', '', error.message.codigoError);
						} else
							this.openModalErrorParent('error', '', error.message.mensaje);
					} else {
						if (error.message.codigoError) {
							if (error.message.codigoError == "eCl00026") { //La contraseña nueva no puede ser la misma que una contraseña utilizada previamente.
								$this.props.alertaClose(error.message.mensajeTecnico, () => {
									$this.props.setPaso(1);
								});
							} else {
								$this.props.alertaCode(error.message.codigoError);
							}
						} else {
							$this.props.alerta(error.message.mensaje);
						}
					}
				});

			} else {
				// GOOGLE TAG MANAGER //
				this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-TERMINOS-RECHAZAR", "dispositivo": this.props.dispositivo });

				let $this = this;
				$this.props.loader(true);
				let llamaServicio = new callService({
					service: "registro.datosCancelacion",
					secure: true,
					data: {
						hashOne: this.props.hashOne,
						hashTwo: this.props.hashTwo
					}
				}).execute().then((respuesta) => {
					console.log("Respuesta", respuesta);
					// let mensaje = {"return": "login"};
					// movil("registroAsistido", mensaje);
					$this.props.loader(false);
					if (this.props.dispositivo === 'app') {
						let mensaje = { "return": "home" };
						movil("", mensaje);
					} else {
						goTo("login");
					}
				}).catch((error) => {
					console.log("Error", error);
					$this.props.loader(false);
					if (this.props.dispositivo === 'app')
						this.openModalErrorParent('error', error.message.codigoError, error.message.mensaje)
					else
						$this.props.alerta(error.message.mensaje);
				});
			}

			resolve();
		});
	}
	enviarLogin = () => {
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_REGISTRO_FINALIZADO-ACEPTAR", "dispositivo": this.props.dispositivo });

		// let mensaje = { "email": this.props.email, "password": this.props.password, "return": "autologin" };
		// movil("registro", mensaje);

		this.props.limpiarRegistro();
		if (this.props.dispositivo === 'app') {
			let mensaje = { "return": "home" };
			movil("", mensaje);
			// this.closeModalFromChild();
		} else {
			goTo("login");
		}
	}

	openModalSucessParent = () => {
		let { isModalSuccessOpened } = this.state;

		if (isModalSuccessOpened)
			this.setState({ isModalSuccessOpened: false })
		else
			this.setState({ isModalSuccessOpened: true });
	}

	closeModalSuccessFromChild = () => {
		this.enviarLogin();
		this.setState({ isModalSuccessOpened: false });
	}

	openModalErrorParent = (type, title, message, errorRedirect = false) => {
		let { isModalErrorOpened } = this.state;

		if (isModalErrorOpened)
			this.setState({ isModalErrorOpened: false, modalMesage: { type: null, title: null, message: null }, errorAndRedirect: false })
		else {
			this.setState({ isModalErrorOpened: true, modalMesage: { type, title, message }, errorAndRedirect: errorRedirect ? errorRedirect : false });
		}
	}

	closeModalErrorFromChild = () => {
		if (this.state.errorAndRedirect) {
			this.setState({ isModalErrorOpened: false, modalMesage: { type: null, title: null, message: null }, errorAndRedirect: false }, () => {
				$this.props.setPaso(1);
			});
		} else
			this.setState({ isModalErrorOpened: false, modalMesage: { type: null, title: null, message: null } });
	}

	render() {
		return (
			<div>
				<ContratoMediosForm onSubmit={this.submit} />
				<div className="modal modal-msj fade" id="modal-bienvenida" tabIndex="-1" role="dialog" aria-labelledby="id-modal-bienvenida">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="">
								<h5 id="id-modal-title" className="text-center">¡Bienvenido!</h5>
							</div>
							<div className="txt-black">
								<p>Tu información se ha guardado satisfactoriamente.</p>
								<p>De ahora en adelante deberás acceder a tu sesión ingresando tu correo y contraseña, mismos que podrás utilizar en la app Soy Cliente GNP. Recibirás un SMS con tu número de cliente, el cual podrás utilizar para los servicios del call center.</p>
							</div>
							<div className="text-center aceptar-cancelar-btn mt-20">
								<button type="button" className="btn orange-btn" onClick={this.enviarLogin} data-dismiss="modal">Aceptar</button>
							</div>
						</div>
					</div>
				</div>

				{this.state.isModalSuccessOpened &&
					<Modal closeModalFromChild={this.closeModalSuccessFromChild}>
						<div>
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
									<img src={require('../img/verified_user_success.svg')} alt="Success image modal" className="gnp-material-comtent-image" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<label className="gnp-material-title-modal">¡Bienvenido!</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
									<div>
										<p className=" gnp-material-content-modal">Tu información se ha guardado satisfactoriamente.</p>
										<p className=" gnp-material-content-modal">Recibirás un SMS con tu número de cliente, el cual  se te solicitará para utilizar los servicios de Call Center. De ahora en adelante deberás acceder a tu sesión ingresando tu usuario y contraseña.</p>
									</div>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.enviarLogin} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</Modal>}

				{this.state.isModalErrorOpened &&
					<Modal closeModalFromChild={this.closeModalErrorFromChild}>
						<div>
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
									<img src={require('../img/warning-new-style.svg')} alt="Error image modal" className="gnp-material-comtent-image" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									{this.state.modalMesage.type !== null ? <label className="gnp-material-title-modal">{this.state.modalMesage.title}</label> : null}
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
									{this.state.modalMesage.type !== null ?
										<p className=" gnp-material-content-modal">{this.state.modalMesage.message}</p>
										:
										null
									}
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.closeModalErrorFromChild} className="pure-material-button-contained btn-full-width">Ok</button>
								</div>
							</div>
						</div>
					</Modal>}
			</div>
		);
	}

}

export default connect(mapState, mapDispatch)(ContratoMedios);



// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/contrato-medios.cmpt.js